import { useState } from 'react';
import { IJobsForTask } from '../Job/types';
import Api from '../Job/API';

export const useJobsForTask = () => {
  const [jobs, setJobs] = useState<IJobsForTask[]>([]);

  const fetchJobs = async () => {
    let page = 1;
    let totalPages = 9999;
    let results: IJobsForTask[] = [];

    while (page <= totalPages) {
      const response = await Api.getJobs(page);
      results = [...results, ...response.data.jobs];
      if (page === 1) {
        setJobs(results);
      }
      totalPages = response.totalPages;
      page += 1;
    }

    if (page > 1) {
      setJobs(results);
    }
  };

  return { jobs, fetchJobs };
};
